/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route__restrictions_tip__selected = /** @type {(inputs: {}) => string} */ () => {
	return `Beschränkungen auf dieser Route`
};

const en_route__restrictions_tip__selected = /** @type {(inputs: {}) => string} */ () => {
	return `Restriction(s) on this route`
};

const es_route__restrictions_tip__selected = /** @type {(inputs: {}) => string} */ () => {
	return `Restricción(es) en este trayecto`
};

const fr_route__restrictions_tip__selected = /** @type {(inputs: {}) => string} */ () => {
	return `Restriction(s) sur ce trajet`
};

const it_route__restrictions_tip__selected = /** @type {(inputs: {}) => string} */ () => {
	return `Restrizione/i su questo percorso`
};

const nl_route__restrictions_tip__selected = /** @type {(inputs: {}) => string} */ () => {
	return `Beperking(en) onderweg`
};

const pt_route__restrictions_tip__selected = /** @type {(inputs: {}) => string} */ () => {
	return `Restrição(ões) neste trajeto`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route__restrictions_tip__selected = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route__restrictions_tip__selected(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route__restrictions_tip__selected", locale)
	if (locale === "de") return de_route__restrictions_tip__selected(inputs)
	if (locale === "en") return en_route__restrictions_tip__selected(inputs)
	if (locale === "es") return es_route__restrictions_tip__selected(inputs)
	if (locale === "fr") return fr_route__restrictions_tip__selected(inputs)
	if (locale === "it") return it_route__restrictions_tip__selected(inputs)
	if (locale === "nl") return nl_route__restrictions_tip__selected(inputs)
	return pt_route__restrictions_tip__selected(inputs)
};